import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <div className="container-app py-16 max-w-3xl">
        <h1 className="font-heading text-4xl font-bold mb-2">Terms of Service</h1>
        <p className="text-muted-foreground mb-8">Last updated: February 2026</p>

        <div className="prose prose-lg max-w-none space-y-6">
          <section>
            <h2 className="text-2xl font-bold">1. Acceptance of Terms</h2>
            <p>By accessing or using the Ready Set STEM website and services, you agree to be bound by these Terms of Service. If you do not agree, please do not use our services.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">2. Services</h2>
            <p>Ready Set STEM provides STEM education courses, workshops, and camps for children. Our services include online course registration, enrollment management, and related educational programs.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">3. Account Registration</h2>
            <p>To enroll in courses, you must create an account. You agree to provide accurate information and keep your account credentials secure. You are responsible for all activity under your account.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">4. Enrollment & Payment</h2>
            <p>Course enrollments are subject to availability. Payments are processed securely through Stripe. All prices are in USD.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">5. Cancellation & Refund Policy</h2>
            <p>Cancellations made 7 or more days before the course start date are eligible for a full refund. Cancellations within 7 days may receive a partial refund or course credit at our discretion. No refunds after the course has started.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">6. Code of Conduct</h2>
            <p>Students are expected to treat all participants, instructors, and staff with respect. Ready Set STEM reserves the right to remove any participant whose behavior disrupts the learning environment.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">7. Intellectual Property</h2>
            <p>All course materials, content, and branding are the property of Ready Set STEM. Materials may not be reproduced or distributed without written permission.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">8. Limitation of Liability</h2>
            <p>Ready Set STEM provides STEM activities that may involve tools, electronics, and materials. While we take safety precautions, participation is at your own risk. Ready Set STEM is not liable for injuries that may occur during normal course activities.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">9. Changes to Terms</h2>
            <p>We may update these terms from time to time. Continued use of our services constitutes acceptance of the updated terms.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold">10. Contact</h2>
            <p>For questions about these terms, contact us at <a href="mailto:info@readysetstem.org" className="text-primary">info@readysetstem.org</a>.</p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t text-center">
          <Link to="/" className="text-primary font-semibold">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
